export default "__VITE_ASSET__6d94201d__"